import { useMemo, useSyncExternalStore } from 'react'
import { ChatConnectionRequestConversation } from '../types/chat'
import { useUser } from 'containers/user/hooks/useUser'
import { chatStore } from '@/components/chat/ChatStore/ChatStore'

export const useChatConnectionsRequest = () => {
  const { user } = useUser()
  const channelsSendbird = useSyncExternalStore(
    chatStore.connectionRequestChannelsCollection.subscribe,
    chatStore.connectionRequestChannelsCollection.getSnapshot
  )

  const connectionsRequests = useMemo(() => {
    return user?.connectionsReceived || []
  }, [user])

  const chatsFromChannels = useMemo(() => {
    if (!channelsSendbird) return []

    return channelsSendbird.map((channel) => {
      // @ts-ignore
      const message = channel?.lastMessage?.message
      const timestamp = channel?.lastMessage?.createdAt
      // @ts-ignore
      const userId = channel?.lastMessage?.sender?.userId
      const id = userId

      return {
        message,
        timestamp,
        id,
        userId,
        channel,
      } as ChatConnectionRequestConversation
    })
  }, [channelsSendbird])

  return useMemo(() => {
    const connectionsReceived = connectionsRequests || []
    const allChats = [...chatsFromChannels, ...connectionsReceived]

    // Filter only request connections with messages
    const filtered = allChats.filter(
      (chat) => typeof chat === 'object' && chat !== null
    ) as ChatConnectionRequestConversation[]

    // filter only with messages
    const filteredWithMessages = filtered.filter((chat) => chat?.message)

    // Remove duplicates by userId
    const uniqueChats = filteredWithMessages.filter(
      (chat, index, self) =>
        index === self.findIndex((t) => t?.userId === chat?.userId)
    )

    // Sort by timestamp desc
    const sortedChats = uniqueChats.sort((a, b) => {
      if (a?.timestamp && b?.timestamp) {
        return b?.timestamp - a?.timestamp
      }

      return 0
    })

    return sortedChats
  }, [chatsFromChannels, connectionsRequests])
}
